function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 .028h15.992V16H0z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 .008)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M15.904 6.866c-.289-1.898-1.136-3.51-2.569-4.794C11.83.722 10.052.044 8.03.028a.755.755 0 0 0-.435.158c-.189.147-.229.369-.148.6.079.224.285.357.534.38.503.046 1.015.055 1.505.164 3.595.807 5.885 4.176 5.326 7.81-.653 4.25-5.127 6.883-9.158 5.388A6.886 6.886 0 0 1 2.41 4.051c.23-.327.507-.621.763-.93l.043.03c-.008.08-.02.16-.024.241-.02.336.187.602.491.635a.564.564 0 0 0 .644-.504c.08-.554.152-1.109.219-1.664a.59.59 0 0 0-.513-.662 91.89 91.89 0 0 0-1.7-.223.569.569 0 0 0-.168 1.124c.116.022.232.037.348.055l.025.056c-.047.036-.101.065-.142.107C.393 4.373-.39 6.828.183 9.636c.958 4.69 5.739 7.433 10.296 5.969 3.67-1.18 6.004-4.933 5.425-8.739",
  fill: "#636365",
  mask: "url(#b)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M8.028 4.031c2.171.015 3.966 1.826 3.955 3.99-.012 2.264-1.8 4.027-4.074 4.015-2.155-.012-3.94-1.837-3.929-4.016A4.008 4.008 0 0 1 8.028 4.03M2.837 8.02a5.153 5.153 0 0 0 5.15 5.161 5.147 5.147 0 0 0-.009-10.293c-2.829 0-5.14 2.308-5.141 5.132",
  fill: "#636365"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.834 8.785h2.255a.502.502 0 1 0 0-1.005H8.525V6.024a.558.558 0 0 0-1.116 0V8.36c0 .234.19.425.425.425",
  fill: "#636365"
}));

function SvgHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.d44f80d3.svg";
export { ForwardRef as ReactComponent };